import { render, staticRenderFns } from "./labelContent.vue?vue&type=template&id=3d9bc3e2&scoped=true&"
import script from "./labelContent.vue?vue&type=script&lang=js&"
export * from "./labelContent.vue?vue&type=script&lang=js&"
import style0 from "./labelContent.vue?vue&type=style&index=0&id=3d9bc3e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9bc3e2",
  null
  
)

export default component.exports